module.exports = __webpack_public_path__ + "99d42f65248f82f71cf6890eb1f3523b.svg";